(function () {
  'use strict';
  const T = window.theme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  // Precio en la moneda del cliente (con mercados internacionales Shopify convierte los precios)
  const fmtMoney = cents => {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100).replace(/[.]00$/, ''); }
    catch (e) { return '$' + (cents / 100).toFixed(2).replace(/[.]00$/, ''); }
  };
  const hasGsap = () => window.gsap && window.ScrollTrigger;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Pantalla de carga ---------- */
  function initLoader() {
    const loader = $('[data-loader]');
    if (!loader) return;
    const bar = $('[data-loader-progress]', loader);
    const finish = () => {
      if (bar) bar.style.width = '100%';
      setTimeout(() => loader.classList.add('is-done'), 250);
      try { sessionStorage.setItem('mp_seen', '1'); } catch (e) {}
    };
    if (document.documentElement.classList.contains('seen-before') || T.designMode) { loader.classList.add('is-done'); return; }
    const imgs = $$('img').filter(i => !i.complete && i.loading !== 'lazy');
    let done = 0;
    const total = imgs.length + 1;
    const step = () => { done++; if (bar) bar.style.width = Math.min(95, (done / total) * 100) + '%'; };
    imgs.forEach(i => { i.addEventListener('load', step, { once: true }); i.addEventListener('error', step, { once: true }); });
    const minTime = new Promise(r => setTimeout(r, 900));
    const loaded = new Promise(r => (document.readyState === 'complete' ? r() : window.addEventListener('load', r, { once: true })));
    const maxTime = new Promise(r => setTimeout(r, 4000));
    Promise.race([Promise.all([minTime, loaded]), maxTime]).then(() => { step(); finish(); });
  }

  /* ---------- Scroll suave ---------- */
  let lenis = null;
  function initSmoothScroll() {
    if (!T.smoothScroll || T.designMode || reduced || !window.Lenis) return;
    lenis = new window.Lenis({ lerp: 0.09, smoothWheel: true });
    if (hasGsap()) {
      lenis.on('scroll', window.ScrollTrigger.update);
      window.gsap.ticker.add(t => lenis.raf(t * 1000));
      window.gsap.ticker.lagSmoothing(0);
    } else {
      const raf = t => { lenis.raf(t); requestAnimationFrame(raf); };
      requestAnimationFrame(raf);
    }
    $$('a[href^="#"]').forEach(a => a.addEventListener('click', e => {
      const id = a.getAttribute('href');
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(el, { offset: -90 });
    }));
  }

  /* ---------- Cabecera y menú móvil ---------- */
  function initHeader() {
    const hdr = $('[data-header]');
    if (hdr) {
      const onScroll = () => hdr.classList.toggle('is-scrolled', window.scrollY > 30);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    const drawer = $('[data-menu-drawer]');
    $$('[data-menu-toggle]').forEach(b => b.addEventListener('click', () => {
      if (!drawer) return;
      const open = drawer.hasAttribute('hidden');
      drawer.toggleAttribute('hidden', !open);
      document.body.style.overflow = open ? 'hidden' : '';
      $$('[data-menu-toggle]').forEach(x => x.setAttribute('aria-expanded', String(open)));
      if (lenis) open ? lenis.stop() : lenis.start();
    }));
  }

  /* ---------- Aparición de bloques ---------- */
  function initReveal() {
    const els = $$('[data-reveal]');
    if (!('IntersectionObserver' in window) || reduced) { els.forEach(e => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver(entries => entries.forEach(en => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -10% 0px' });
    els.forEach(e => io.observe(e));
  }

  /* ---------- Historia con vídeos que avanzan con el scroll ---------- */
  /* ---------- Vídeo del hero ----------
     Bucle silencioso. Se pausa fuera de pantalla y con la pestaña oculta.
     Con "reducir movimiento" o ahorro de datos se queda la imagen fija. */
  function initHeroVideo(sec) {
    const v = $('video', sec);
    if (!v || sec.dataset.ready) return;
    sec.dataset.ready = '1';
    const saveData = !!(navigator.connection && navigator.connection.saveData);
    if (reduced || saveData) { v.removeAttribute('autoplay'); v.pause(); v.hidden = true; return; }
    v.muted = true;
    const play = () => { const p = v.play(); if (p && p.catch) p.catch(() => {}); };
    v.addEventListener('playing', () => sec.classList.add('is-playing'), { once: true });
    new IntersectionObserver(([en]) => { en.isIntersecting ? play() : v.pause(); }).observe(sec);
    document.addEventListener('visibilitychange', () => { document.hidden ? v.pause() : play(); });
  }

  // Vista previa sin producto: el precio cambia al elegir la talla
  function initDemoSizes(root) {
    $$('[data-demo-size]', root).forEach(i => i.addEventListener('change', () => {
      const block = i.closest('[data-product-block]');
      const price = block && $('[data-demo-price]', block);
      if (price) price.textContent = i.dataset.demoSize;
    }));
  }

  /* ---------- Producto ---------- */
  function initProduct(block) {
    const mainEl = $('[data-pdp-main]', block);
    const thumbsEl = $('[data-pdp-thumbs]', block);
    let main = null;
    if (window.Swiper && mainEl) {
      const thumbs = thumbsEl ? new window.Swiper(thumbsEl, { slidesPerView: 'auto', spaceBetween: 10, freeMode: true, watchSlidesProgress: true }) : null;
      main = new window.Swiper(mainEl, {
        spaceBetween: 0, speed: 600,
        navigation: { nextEl: $('.swiper-button-next', mainEl), prevEl: $('.swiper-button-prev', mainEl) },
        thumbs: thumbs ? { swiper: thumbs } : undefined
      });
    }

    const form = $('[data-product-form]', block);
    const jsonEl = $('[data-product-json]', block);
    if (!form || !jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const idInput = $('[data-variant-id]', form);
    const addBtn = $('[data-add-button]', form);
    const addLabel = $('[data-add-label]', form);
    const priceEl = $('[data-price-current]', block);
    const compareEl = $('[data-price-compare]', block);
    const badgeEl = $('[data-price-badge]', block);
    const money = cents => {
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100).replace(/[.]00$/, ''); }
      catch (e) { return '$' + (cents / 100).toFixed(2); }
    };

    function currentOptions() {
      return product.options.map((_, i) => {
        const c = $('input[data-option-index="' + i + '"]:checked', form);
        return c ? c.value : null;
      });
    }

    function update() {
      const opts = currentOptions();
      const variant = product.variants.find(v => v.options.every((o, i) => o === opts[i]));
      opts.forEach((o, i) => { const l = $('[data-option-label="' + i + '"]', form); if (l) l.textContent = o; });
      if (!variant) {
        addBtn.disabled = true; addLabel.textContent = (window.MELT_T && MELT_T.unavailable) || 'Unavailable'; return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (priceEl) priceEl.textContent = money(variant.price);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = money(variant.compare_at_price); }
      if (badgeEl) { badgeEl.hidden = !onSale; if (onSale) badgeEl.textContent = 'Save ' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%'; }
      if (variant.featured_media && main) {
        const idx = $$('.swiper-slide', mainEl).findIndex(s => s.dataset.mediaId == variant.featured_media.id);
        if (idx >= 0) main.slideTo(idx);
      }
      const url = new URL(window.location.href);
      if (url.pathname.includes('/products/')) { url.searchParams.set('variant', variant.id); history.replaceState(null, '', url); }
    }
    $$('input[data-option-index]', form).forEach(i => i.addEventListener('change', update));

    const qty = $('[data-qty-input]', form);
    $('[data-qty-minus]', form)?.addEventListener('click', () => { qty.value = Math.max(1, (+qty.value || 1) - 1); });
    $('[data-qty-plus]', form)?.addEventListener('click', () => { qty.value = (+qty.value || 1) + 1; });

    // Añadir al carrito sin salir de la página
    form.addEventListener('submit', async e => {
      if (!window.fetch) return;
      e.preventDefault();
      addBtn.disabled = true;
      try {
        const res = await fetch((T.routes && T.routes.cartAdd || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +idInput.value, quantity: +qty.value || 1, properties: { _pack: newPack() } }] })
        });
        if (!res.ok) throw new Error((await res.json()).description || 'Error');
        await refreshCartCount();
        showToast();
      } catch (err) {
        alert(err.message);
      } finally {
        addBtn.disabled = false;
      }
    });
  }

  async function refreshCartCount() {
    try {
      const cart = await (await fetch((T.routes && T.routes.cart || '/cart') + '.js')).json();
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    } catch (e) {}
  }
  let toastTimer;
  function showToast() {
    const t = $('[data-cart-toast]');
    if (!t) return;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { t.hidden = true; }, 5000);
  }
  // Para otras secciones (p. ej. Video showcase) que añaden al carrito por su cuenta
  T.cartAdded = async () => { await refreshCartCount(); showToast(); };

  /* ---------- Reseñas ---------- */
  function initMoments() {
    const vids = $$('[data-mo-src]');
    if (!vids.length) return;
    const load = v => { if (!v.src) { v.src = v.dataset.moSrc; } };
    if (!('IntersectionObserver' in window)) { vids.forEach(v => { load(v); v.play().catch(() => {}); }); return; }
    const io = new IntersectionObserver(entries => entries.forEach(en => {
      const v = en.target;
      if (en.isIntersecting) { load(v); if (!reduced) v.play().catch(() => {}); }
      else v.pause();
    }), { rootMargin: '200px 0px', threshold: 0.25 });
    vids.forEach(v => io.observe(v));
  }

  function initProtection() {
    $$('[data-addon]').forEach(box => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      box.addEventListener('change', async () => {
        const label = box.closest('.prot');
        if (label) label.classList.add('is-busy');
        box.disabled = true;
        try {
          if (box.checked) {
            const p = await fetch('/products/' + box.dataset.addonHandle + '.js').then(r => r.json());
            const v = (p.variants || []).find(x => x.available) || p.variants[0];
            await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) });
          } else if (box.dataset.addonKey) {
            await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: box.dataset.addonKey, quantity: 0 }) });
          }
        } catch (e) {}
        location.reload();
      });
    });
  }

  function initPhotoReviews() {
    $$('[data-rv-photos]').forEach(wrap => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const track = $('[data-rv-track]', wrap);
      const prev = $('[data-rv-prev]', wrap), next = $('[data-rv-next]', wrap);
      if (!track) return;
      const step = () => { const t = track.firstElementChild; return t ? t.getBoundingClientRect().width + 16 : track.clientWidth * 0.8; };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        const fits = max <= 0;
        wrap.classList.toggle('rv-fits', fits);
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      };
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      // Arrastrar con el ratón en ordenador
      let down = false, startX = 0, startL = 0, moved = false;
      track.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; moved = false; startX = e.clientX; startL = track.scrollLeft; track.classList.add('is-drag'); });
      window.addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = startL - dx; });
      window.addEventListener('pointerup', () => { if (!down) return; down = false; track.classList.remove('is-drag'); });
      track.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
      track.querySelectorAll('img').forEach(i => { i.draggable = false; i.addEventListener('load', update); });
      update();
    });
  }

  function initReviews() {
    $$('[data-reviews]').forEach(el => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      // Cinta continua que se desliza sola (CSS). Se duplican las tarjetas para que el bucle no tenga saltos.
      const track = $('.swiper-wrapper', el);
      const slides = $$('.swiper-slide', el);
      if (track && slides.length > 2 && !reduced) {
        slides.forEach(s => {
          const c = s.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          $$('a, button', c).forEach(b => b.setAttribute('tabindex', '-1'));
          track.appendChild(c);
        });
        el.classList.add('is-marquee', 'is-js');
        const dur = Math.max(30, slides.length * 6); // segundos para recorrer la mitad (las tarjetas originales)
        let x = 0, target = null, last = performance.now(), hover = false;
        el.addEventListener('mouseenter', () => { hover = true; });
        el.addEventListener('mouseleave', () => { hover = false; });
        const half = () => track.scrollWidth / 2 + 9;
        const step = () => { const s = slides[0].getBoundingClientRect().width; return s + 18; };
        const norm = h => { while (x < 0) { x += h; if (target !== null) target += h; } while (x >= h) { x -= h; if (target !== null) target -= h; } };
        const tick = now => {
          const dt = Math.min(0.05, (now - last) / 1000); last = now;
          const h = half();
          if (target !== null) {
            x += (target - x) * Math.min(1, dt * 9);
            if (Math.abs(target - x) < 0.5) { x = target; target = null; }
          } else if (!hover && !el.classList.contains('has-open') && !el.classList.contains('is-held')) {
            x += (h / dur) * dt;
          }
          norm(h);
          track.style.transform = 'translate3d(' + (-x).toFixed(2) + 'px,0,0)';
          requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        const shell = el.closest('.reviews-shell');
        const go = dir => { target = (target === null ? x : target) + dir * step(); };
        if (shell) {
          const p = $('[data-reviews-prev]', shell), n = $('[data-reviews-next]', shell);
          if (p) p.addEventListener('click', () => go(-1));
          if (n) n.addEventListener('click', () => go(1));
        }
        // En el móvil, tocar la cinta la para; volver a tocar la reanuda
        el.addEventListener('touchstart', () => el.classList.toggle('is-held'), { passive: true });
      }
      // Tarjetas del mismo tamaño: el texto largo se recorta y "Read more" lo abre
      $$('[data-review-text]', el).forEach(t => {
        const more = t.parentElement.querySelector('[data-review-more]');
        if (!more) return;
        // Se mide cuando ya cargaron fuentes y estilos
        const check = () => { if (!t.classList.contains('is-open')) more.hidden = t.scrollHeight <= t.clientHeight + 2; };
        check();
        window.addEventListener('load', check);
        window.addEventListener('resize', check);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
        more.addEventListener('click', () => {
          const open = t.classList.toggle('is-open');
          t.closest('.review').classList.toggle('is-open', open);
          more.textContent = open ? 'Show less' : 'Read more';
          // Mientras se lee una reseña larga, la cinta se queda quieta
          el.classList.toggle('has-open', !!el.querySelector('.review.is-open'));
        });
      });
    });
  }

  /* ---------- Cookies (Customer Privacy API de Shopify) ---------- */
  function initCookies() {
    const banner = $('[data-cookie-banner]');
    const KEY = 'mp_consent';
    let api = null;
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } };
    const save = c => { try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {} };

    function apply(consent) {
      save(consent);
      if (api && api.setTrackingConsent) {
        api.setTrackingConsent({
          analytics: !!consent.analytics,
          marketing: !!consent.marketing,
          preferences: !!consent.preferences,
          sale_of_data: !!consent.sale_of_data
        }, () => {});
      }
      if (banner) banner.hidden = true;
    }
    const all = v => ({ analytics: v, marketing: v, preferences: v, sale_of_data: v });

    function show(prefs) {
      if (!banner) return;
      banner.hidden = false;
      $('[data-cookie-main]', banner).hidden = !!prefs;
      $('[data-cookie-prefs]', banner).hidden = !prefs;
      if (prefs) {
        const c = read() || all(false);
        ['analytics', 'marketing', 'preferences', 'sale_of_data'].forEach(k => {
          const i = $('input[name="' + k + '"]', banner); if (i) i.checked = !!c[k];
        });
      }
    }

    if (banner) {
      $$('[data-cookie-accept]', banner).forEach(b => b.addEventListener('click', () => apply(all(true))));
      $('[data-cookie-reject]', banner)?.addEventListener('click', () => apply(all(false)));
      $('[data-cookie-open-prefs]', banner)?.addEventListener('click', () => show(true));
      $('[data-cookie-prefs]', banner)?.addEventListener('submit', e => {
        e.preventDefault();
        const f = e.currentTarget;
        apply({ analytics: f.analytics.checked, marketing: f.marketing.checked, preferences: f.preferences.checked, sale_of_data: f.sale_of_data.checked });
      });
    }
    $$('[data-cookie-reopen]').forEach(b => b.addEventListener('click', () => show(true)));
    $$('[data-do-not-sell]').forEach(b => b.addEventListener('click', () => {
      const c = Object.assign(all(false), read() || {}, { sale_of_data: false });
      apply(c);
      alert('Done. We will not sell or share your personal information.');
    }));

    const decide = () => { if (!read() && !T.designMode) show(false); };
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], err => {
        if (!err) api = window.Shopify.customerPrivacy;
        decide();
      });
    } else {
      decide();
    }
  }

  /* ---------- Compra rápida flotante ----------
     Aparece al pasar 300 px de scroll, se oculta mientras una ficha de compra está en pantalla
     y añade al carrito la talla elegida en la ficha de la portada (o la primera disponible). */
  function initQuickBuy() {
    const qb = $('[data-quick-buy]');
    if (!qb || qb.dataset.ready) return;
    qb.dataset.ready = '1';
    const btn = $('[data-qb-add]', qb);
    const focusables = $$('a, button', qb);
    const hdr = $('[data-header]');
    let buyInView = false;
    let shown = false;

    const placeBelowHeader = () => {
      const h = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0;
      qb.style.setProperty('--qb-top', Math.round(h + 12) + 'px');
    };
    // Ocultar solo mientras un botón de compra de la página está a la vista.
    // (Antes se miraba la sección entera y en pantallas altas de PC casi nunca aparecía.)
    const zones = $$('[data-hb-add], [data-bo-add], [data-add-button], [data-bb-add], [data-bb-add-qty]');
    const zoneOnScreen = () => zones.some(z => {
      const r = z.getBoundingClientRect();
      return r.height > 0 && r.top > 0 && r.bottom < window.innerHeight;
    });

    const update = () => {

      placeBelowHeader();
      buyInView = zoneOnScreen();
      // La portada carga limpia: aparece cuando el cliente baja más allá de la primera pantalla
      // y desde ahí se queda siempre (no se quita al seguir haciendo scroll)
      if (!shown && window.scrollY > window.innerHeight * 0.6) shown = true;
      const show = shown;
      qb.classList.toggle('is-visible', show);
      qb.setAttribute('aria-hidden', show ? 'false' : 'true');
      focusables.forEach(el => { el.tabIndex = show ? 0 : -1; });
    };
    const onScroll = () => update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
    update();

    // Un clic: añade el pack de 3 (2 + 1 gratis) en la talla elegida y lleva al carrito
    btn.addEventListener('click', async () => {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('is-loading');
      const picked = $('[data-bo-size]:checked');
      const id = +(picked ? picked.value : qb.dataset.variant);
      try {
        await cartPost('/cart/add.js', { items: [{ id, quantity: 3, properties: { _pack: newPack() } }] });
        window.location.href = (T.routes && T.routes.cart) || '/cart';
      } catch (err) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        window.location.href = qb.dataset.url;
      }
    });
  }

  /* ---------- FAQ flotante ----------
     Una sola respuesta abierta; se cierra al pulsar fuera o con Esc. */
  /* ---------- Botones "Get cozy" / "Get it now": van directo al precio, la talla y los botones de compra ---------- */
  function initBuyFocus() {
    const go = (el, smooth) => {
      const top = el.getBoundingClientRect().top + window.scrollY - 76;
      if (lenis) lenis.scrollTo(top, { immediate: !smooth });
      else window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
    };
    const focusOf = id => {
      const sec = id && id.length > 1 ? document.querySelector(id) : null;
      return sec ? (sec.matches('[data-buy-focus]') ? sec : $('[data-buy-focus]', sec)) : null;
    };
    document.addEventListener('click', e => {
      const a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = focusOf(a.getAttribute('href'));
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      go(el, true);
    }, true);
    const el = focusOf(location.hash);
    if (el) window.addEventListener('load', () => setTimeout(() => go(el, false), 60));
  }

  function initFaqPop() {
    const items = $$('[data-faq-pop]');
    if (!items.length) return;
    items.forEach(d => d.addEventListener('toggle', () => {
      if (d.open) items.forEach(o => { if (o !== d && o.open) o.open = false; });
    }));
    document.addEventListener('click', e => {
      items.forEach(d => { if (d.open && !d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      items.forEach(d => {
        if (!d.open) return;
        d.open = false;
        const s = $('summary', d);
        if (s && d.contains(document.activeElement)) s.focus();
      });
    });
  }

  /* ---------- Oferta por cantidad (Buy more, save more) ---------- */
  function initBundle(sec) {
    if (sec.dataset.ready) return;
    sec.dataset.ready = '1';
    const fmt = fmtMoney;
    const main = $('[data-bo-main]', sec);
    // Miniaturas: foto o vídeo (el vídeo se reproduce en silencio y en bucle)
    const box = main && main.parentElement;
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const thumbs = $$('[data-bo-thumb]', sec);
    const thumbsBox = $('.bo__thumbs', sec);
    let auto = !reduced, timer = 0, inView = false, hovering = false, resumeAt = 0;
    const show = (t, fromAuto) => {
      if (t.classList.contains('is-active') && (!t.dataset.boVideo || $('video', box))) return;
      const old = box && $('video', box);
      if (old) old.remove();
      if (t.dataset.boVideo && box) {
        if (main) main.hidden = true;
        const v = document.createElement('video');
        // En el pase automático el vídeo se ve entero y luego sigue; elegido a mano, se repite
        Object.assign(v, { src: t.dataset.boVideo, poster: t.dataset.boThumb, muted: true, loop: !fromAuto, playsInline: true, autoplay: !reduced, controls: reduced });
        v.className = 'bo__video';
        v.muted = true;
        if (fromAuto) v.addEventListener('ended', () => { if (auto) next(); });
        box.appendChild(v);
        if (!reduced) v.play().catch(() => { v.controls = true; });
      } else if (main) {
        main.hidden = false;
        main.removeAttribute('srcset'); main.src = t.dataset.boThumb;
      }
      thumbs.forEach(x => x.classList.toggle('is-active', x === t));
      // Mantener visible la miniatura activa dentro de su columna (sin mover la página)
      if (thumbsBox) {
        const vertical = thumbsBox.scrollHeight > thumbsBox.clientHeight + 2;
        if (vertical) thumbsBox.scrollTo({ top: t.offsetTop - thumbsBox.clientHeight / 2 + t.offsetHeight / 2, behavior: 'smooth' });
        else thumbsBox.scrollTo({ left: t.offsetLeft - thumbsBox.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
      }
    };
    // Pase automático: cada foto 3,5 s; el vídeo hasta que termina
    function schedule() {
      clearTimeout(timer);
      if (!auto || thumbs.length < 2) return;
      const cur = thumbs.find(x => x.classList.contains('is-active'));
      const v = cur && cur.dataset.boVideo && $('video', box);
      // En el pase automático el vídeo sigue al terminar ('ended'); como tope, 12 s por si no llega a reproducirse
      timer = setTimeout(next, v ? (v.loop ? 9000 : 12000) : 3500);
    }
    const visible = () => {
      if (!gallery) return true;
      const r = gallery.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
      return inView || (r.bottom > 80 && r.top < vh - 80);
    };
    function next() {
      if (!visible() || hovering || Date.now() < resumeAt) { schedule(); return; }
      const i = thumbs.findIndex(x => x.classList.contains('is-active'));
      show(thumbs[(i + 1) % thumbs.length], true);
      schedule();
    }
    // Flechas sobre la imagen grande: anterior / siguiente (pausan el pase 8 s)
    const step = d => {
      const i = thumbs.findIndex(x => x.classList.contains('is-active'));
      resumeAt = Date.now() + 8000;
      show(thumbs[(i + d + thumbs.length) % thumbs.length]);
      schedule();
    };
    const pBtn = $('[data-bo-prev]', sec), nBtn = $('[data-bo-next]', sec);
    if (pBtn) pBtn.addEventListener('click', () => step(-1));
    if (nBtn) nBtn.addEventListener('click', () => step(1));
    // Clic en móvil y PC; en PC también al pasar el ratón por encima. Tocar pausa el pase 8 s.
    thumbs.forEach(t => {
      t.addEventListener('click', () => { resumeAt = Date.now() + 8000; show(t); schedule(); });
      if (canHover) t.addEventListener('mouseenter', () => show(t));
    });
    const gallery = $('.bo__gallery', sec);
    if (gallery) {
      gallery.addEventListener('mouseenter', () => { hovering = true; });
      gallery.addEventListener('mouseleave', () => { hovering = false; schedule(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(es => { inView = es[0].isIntersecting; if (inView) schedule(); }, { threshold: 0.4 }).observe(gallery);
      } else inView = true;
    }
    schedule();

    const addBtn = $('[data-bo-add]', sec);
    const addLabel = $('[data-bo-add-label]', sec);
    const unit = $('[data-bo-unit]', sec);
    const sizes = $$('[data-bo-size]', sec);
    const tiers = $$('[data-bo-tier]', sec);
    const variant = () => { const c = sizes.find(i => i.checked); return c ? c.value : sec.dataset.variant; };
    const price = () => { const c = sizes.find(i => i.checked); return +(c ? c.dataset.price : sec.dataset.price); };
    const tier = () => tiers.find(i => i.checked) || tiers[0];

    const unitWas = $('[data-bo-unit-was]', sec), unitQty = $('[data-bo-unit-qty]', sec);
    function refresh() {
      const p = price();
      // El precio grande sigue a la opción elegida: total del pack, con el precio sin descuento tachado
      const sel = tier(), selQ = sel ? +sel.dataset.qty : 1, selS = sel ? (+sel.dataset.free || 0) * p : 0;
      if (unit) unit.textContent = fmt(p * selQ - selS);
      if (unitWas) { unitWas.hidden = selS <= 0; unitWas.textContent = fmt(p * selQ); }
      if (unitQty) unitQty.textContent = selQ > 1 ? 'for ' + selQ + ' blankets' : '';
      tiers.forEach(t => {
        const lab = t.closest('label');
        const qty = +t.dataset.qty, saveC = (+t.dataset.free || 0) * p;
        const total = $('[data-bo-total]', lab), save = $('[data-bo-save]', lab);
        const was = $('[data-bo-was]', lab);
        if (was) was.textContent = fmt(p * qty);
        if (total) total.textContent = fmt(p * qty - saveC);
        if (save) save.textContent = ((window.MELT_T && MELT_T.save) || 'Save') + ' ' + fmt(saveC);
      });
      const t = tier();
      if (addLabel && t) addLabel.textContent = +t.dataset.qty > 1 ? 'Add ' + t.dataset.qty + ' to cart' : 'Add to cart';
    }
    sizes.forEach(i => i.addEventListener('change', refresh));
    tiers.forEach(i => i.addEventListener('change', refresh));
    refresh();

    addBtn && addBtn.addEventListener('click', async () => {
      if (addBtn.disabled) return;
      addBtn.disabled = true;
      const t = tier();
      try {
        const res = await fetch((T.routes && T.routes.cartAdd || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +variant(), quantity: t ? +t.dataset.qty : 1, properties: { _pack: newPack() } }] })
        });
        if (!res.ok) throw new Error((await res.json()).description || 'Error');
        await refreshCartCount();
        showToast();
      } catch (err) {
        alert(err.message);
      } finally {
        addBtn.disabled = false;
      }
    });

    // Contador opcional: solo con una fecha de fin real y futura
    const cd = $('[data-bo-countdown]', sec);
    if (cd) {
      const end = new Date(cd.dataset.boCountdown).getTime();
      const h = $('[data-h]', cd), m = $('[data-m]', cd), s = $('[data-s]', cd);
      const pad = n => String(n).padStart(2, '0');
      const tick = () => {
        const left = Math.floor((end - Date.now()) / 1000);
        if (!end || left <= 0) { cd.hidden = true; clearInterval(timer); return; }
        cd.hidden = false;
        h.textContent = pad(Math.floor(left / 3600)); m.textContent = pad(Math.floor(left % 3600 / 60)); s.textContent = pad(left % 60);
      };
      const timer = setInterval(tick, 1000);
      tick();
    }
  }

  /* ---------- Carrito: subir a 2 o 3 unidades ---------- */
  // Cada pack del carrito lleva la propiedad oculta _pack, así no se mezcla con otros.
  const newPack = () => 'p' + Date.now().toString(36);
  async function cartPost(url, body) {
    // En el carrito se pide también la sección ya pintada: una sola petición.
    const sec = document.querySelector('[data-cart-section]');
    if (sec) body = Object.assign({}, body, { sections: sec.dataset.cartSection, sections_url: window.location.pathname });
    const res = await fetch(url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || 'Error');
    return data;
  }
  // Vuelve a pintar solo la sección del carrito (sin recargar la página).
  async function cartRerender(data) {
    const sec = $('[data-cart-section]');
    if (!sec) { window.location.reload(); return; }
    const id = sec.dataset.cartSection;
    let html = data && data.sections && data.sections[id];
    if (!html) html = (await (await fetch(window.location.pathname + '?sections=' + encodeURIComponent(id))).json())[id];
    if (!html) { window.location.reload(); return; }
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
    // Precio anterior de cada pack, para que el nuevo "cuente" hasta su valor.
    const before = {};
    $$('[data-pack]', sec).forEach(p => { const n = $('.cart__now', p); if (n && p.dataset.packId) before[p.dataset.packId] = +n.dataset.cents; });
    sec.replaceWith(fresh);
    $$('[data-pack]', fresh).forEach(p => {
      const n = $('.cart__now', p), from = before[p.dataset.packId], to = n ? +n.dataset.cents : 0;
      if (!n || from == null || from === to) return;
      p.classList.add('is-changed');
      if (reduced) return;
      const fmt = fmtMoney;
      const t0 = performance.now(), dur = 600;
      const step = t => {
        const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        n.textContent = fmt(Math.round(from + (to - from) * e));
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
    $$('[data-pack]', fresh).forEach(initCartPack);
    $$('[data-pack-add]', fresh).forEach(initPackAdd);
    initProgSteps(fresh);
    syncChecked(fresh);
    refreshCartCount();
  }
  function initCartPack(box) {
    // Shopify parte un pack en varias líneas al aplicar el regalo:
    // la cantidad elegida va en la primera y las demás quedan a 0.
    const keys = (box.dataset.keys || '').split(',').filter(Boolean);
    const run = async fn => {
      box.classList.add('is-busy');
      $$('input,button', box).forEach(el => { el.disabled = true; });
      try { await cartRerender(await fn()); }
      catch (err) { window.location.reload(); }
    };
    $$('[data-pack-tier]', box).forEach(r => r.addEventListener('change', () => run(() => {
      if (!keys.length) return cartPost('/cart/add.js', { items: [{ id: +box.dataset.variant, quantity: +r.value, properties: { _pack: newPack() } }] });
      const updates = {};
      keys.forEach((k, i) => { updates[k] = i ? 0 : +r.value; });
      return cartPost('/cart/update.js', { updates });
    })));
    // Talla: con carrito vacío solo cambia los precios; en un pack se cambia la talla de todo el pack.
    const fmt = fmtMoney;
    $$('[data-pack-size]', box).forEach(r => r.addEventListener('change', () => {
      if (!keys.length) {
        box.dataset.variant = r.value;
        const p = +r.dataset.price;
        $$('[data-cup-total]', box).forEach(el => { el.textContent = fmt(p * +el.dataset.qty - (+el.dataset.free || 0) * p); });
        $$('[data-cup-save]', box).forEach(el => { el.textContent = ((window.MELT_T && MELT_T.save) || 'Save') + ' ' + fmt((+el.dataset.free || 0) * p); });
        // Precio de comparación: 1 manta = precio anterior de la talla; 3 mantas = lo que costarían sueltas
        const cmp = +r.dataset.compare || 0;
        $$('[data-cup-was]', box).forEach(el => {
          const v = +el.dataset.qty === 1 ? cmp : p * +el.dataset.qty;
          el.textContent = fmt(v);
          const q = +el.dataset.qty;
          el.hidden = !(v > p * q - Math.floor(q / 3) * p);
        });
        return;
      }
      run(async () => {
        const updates = {};
        keys.forEach(k => { updates[k] = 0; });
        await cartPost('/cart/update.js', { updates });
        return cartPost('/cart/add.js', { items: [{ id: +r.value, quantity: +box.dataset.units || 1, properties: { _pack: box.dataset.packId || newPack() } }] });
      });
    }));
    const rm = $('[data-pack-remove]', box);
    rm && rm.addEventListener('click', () => run(() => {
      const updates = {};
      keys.forEach(k => { updates[k] = 0; });
      return cartPost('/cart/update.js', { updates });
    }));
  }
  // Los pasos de la barra de progreso eligen 1, 2 o 3 en el pack.
  function initProgSteps(root) {
    $$('[data-step]', root).forEach(b => b.addEventListener('click', () => {
      const r = $('.pack [data-pack-tier][value="' + b.dataset.step + '"]', root);
      if (r && !r.checked) r.click();
    }));
  }
  function initPackAdd(btn) {
    btn.addEventListener('click', async () => {
      btn.disabled = true;
      try {
        await cartRerender(await cartPost('/cart/add.js', { items: [{ id: +btn.dataset.variant, quantity: 1, properties: { _pack: newPack() } }] }));
      } catch (err) { btn.disabled = false; alert(err.message); }
    });
  }

  /* ---------- Barra de compra de la portada (1 / 2 / 3 mantas) ---------- */
  function initHeroBundle(bar) {
    const fmt = fmtMoney;
    const unit = $('[data-hb-unit]', bar), label = $('[data-hb-label]', bar), btn = $('[data-hb-add]', bar);
    const sizes = $$('[data-hb-size]', bar), tiers = $$('[data-hb-tier]', bar);
    const size = () => sizes.find(i => i.checked);
    const tier = () => tiers.find(i => i.checked) || tiers[0];
    function refresh() {
      const s = size(), p = +(s ? s.dataset.price : bar.dataset.price), t = tier();
      if (unit) unit.textContent = fmt(p * +t.value - (+t.dataset.free || 0) * p);
      const q = +t.value;
      label.textContent = (q > 1 ? 'Get ' + q + ' blankets' : 'Get my MeltLoft') + ' — ' + fmt(p * q - (+t.dataset.free || 0) * p);
    }
    sizes.forEach(i => i.addEventListener('change', refresh));
    tiers.forEach(i => i.addEventListener('change', refresh));
    refresh();
    btn && btn.addEventListener('click', async () => {
      btn.disabled = true;
      const s = size();
      try {
        await cartPost('/cart/add.js', { items: [{ id: +(s ? s.value : bar.dataset.variant), quantity: +tier().value, properties: { _pack: newPack() } }] });
        window.location.href = (T.routes && T.routes.cart) || '/cart';
      } catch (err) { btn.disabled = false; alert(err.message); }
    });
  }

  /* ---------- Opción marcada visible en todos los móviles ----------
     Los estilos usan :has(input:checked); algunos móviles antiguos no lo entienden,
     así que también se marca la etiqueta con la clase .is-checked. */
  const TIER_SEL = '.bo__tier, .hb__tier, .seg__opt';
  function syncChecked(root) {
    $$(TIER_SEL, root || document).forEach(l => {
      const i = $('input[type="radio"]', l);
      l.classList.toggle('is-checked', !!(i && i.checked));
    });
  }
  document.addEventListener('change', e => {
    if (e.target.matches && e.target.matches('input[type="radio"]') && e.target.closest(TIER_SEL)) syncChecked();
  });

  /* ---------- Bloque de compra (pack 2 + 1 gratis y compra suelta) ---------- */
  function initBuyBox(sec) {
    if (!$('.bb-pack', sec) || sec.dataset.bbReady) return;
    sec.dataset.bbReady = '1';
    const fmt = fmtMoney;
    const sizes = $$('[data-bo-size]', sec);
    const variant = () => { const c = sizes.find(i => i.checked); return +(c ? c.value : sec.dataset.variant); };
    const price = () => { const c = sizes.find(i => i.checked); return +(c ? c.dataset.price : sec.dataset.price); };
    const set = (sel, txt) => { const el = $(sel, sec); if (el) el.textContent = txt; };
    const compare = () => { const c = sizes.find(i => i.checked); return +((c && c.dataset.compare) || 0); };
    function refresh() {
      const p = price();
      set('[data-bb-price]', fmt(p));
      const was = $('[data-bb-was]', sec), c = compare();
      if (was) { was.hidden = !(c > p); if (c > p) was.textContent = fmt(c); }
      set('[data-bb-orig]', fmt(p * 3));
      set('[data-bb-pack]', fmt(p * 2));
      set('[data-bb-save]', fmt(p));
      ['[data-bb-save2]', '[data-bb-save3]', '[data-bb-save4]'].forEach(sel => set(sel, fmt(p)));
      set('[data-bb-pack2]', fmt(p * 2));
      const st = $('[data-bb-stock]', sec), info = $('[data-stock-for="' + variant() + '"]', sec);
      if (st) {
        // Si el inventario de Shopify esta activado manda ese numero, porque baja solo
        // con cada venta. Si no, se usa el que haya escrito en el editor para esa talla,
        // que son las unidades que el proveedor tiene en almacen.
        const real = info && info.dataset.tracked ? +info.dataset.qty : 0;
        const manual = info ? +info.dataset.manual : 0;
        const n = real > 0 ? real : manual;
        const show = n > 0 && n <= 50;
        st.hidden = !show;
        if (show) set('[data-bb-stock-n]', n);
      }
    }
    sizes.forEach(i => i.addEventListener('change', refresh));
    refresh();
    const qty = $('[data-bb-qty]', sec);
    const clamp = n => Math.max(1, Math.min(10, n || 1));
    $('[data-bb-minus]', sec)?.addEventListener('click', () => { qty.value = clamp(+qty.value - 1); });
    $('[data-bb-plus]', sec)?.addEventListener('click', () => { qty.value = clamp(+qty.value + 1); });
    async function add(btn, n, then) {
      if (btn.disabled) return;
      btn.disabled = true;
      try {
        await cartPost('/cart/add.js', { items: [{ id: variant(), quantity: n, properties: { _pack: newPack() } }] });
        window.location.href = then;
      } catch (err) { alert(err.message); btn.disabled = false; }
    }
    const cartUrl = (T.routes && T.routes.cart) || '/cart';
    const packBtn = $('[data-bb-add]', sec);
    packBtn && packBtn.addEventListener('click', () => add(packBtn, 3, cartUrl));
    const addBtn = $('[data-bb-add-qty]', sec);
    addBtn && addBtn.addEventListener('click', () => add(addBtn, clamp(+qty.value), cartUrl));
    const nowBtn = $('[data-bb-now]', sec);
    nowBtn && nowBtn.addEventListener('click', () => add(nowBtn, clamp(+qty.value), cartUrl));
  }

  /* ---------- Arranque ---------- */
  function boot() {
    syncChecked();
    if (hasGsap()) window.gsap.registerPlugin(window.ScrollTrigger);
    initLoader();
    initSmoothScroll();
    initHeader();
    initReveal();
    $$('[data-hero-video]').forEach(initHeroVideo);
    $$('[data-product-block]').forEach(initProduct);
    initDemoSizes(document);
    initReviews();
    initPhotoReviews();
    initProtection();
    initMoments();
    initCookies();
    initQuickBuy();
    initBuyFocus();
    initFaqPop();
    $$('[data-bundle-offer]').forEach(initBundle);
    $$('[data-bundle-offer]').forEach(initBuyBox);
    $$('[data-pack]').forEach(initCartPack);
    $$('[data-pack-add]').forEach(initPackAdd);
    initProgSteps(document);
    $$('[data-hero-bundle]').forEach(initHeroBundle);
    if (hasGsap()) window.addEventListener('load', () => window.ScrollTrigger.refresh());
  }

  // Editor de temas: volver a iniciar al editar secciones
  document.addEventListener('shopify:section:load', e => {
    $$('[data-hero-video]', e.target).forEach(initHeroVideo);
    $$('[data-product-block]', e.target).forEach(initProduct);
    initDemoSizes(e.target);
    $$('[data-reveal]', e.target).forEach(el => el.classList.add('is-in'));
    initReviews();
    if (hasGsap()) window.ScrollTrigger.refresh();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
